import useWindowResize from "@/hooks/useWindowResize";
import { truncateText } from "@/utils/helper";
import { Modal } from "antd";
import { useRouter } from "next/router";
import { ReactNode, useEffect, useState } from "react";

interface IContent {
  title: string;
  description: string;
}

export function ModalReadMore() {
  const router = useRouter();
  const [openModalReadMoreDesc, openModalReadMoreDescSet] =
    useState<IContent | null>(null);

  useEffect(() => {
    if (router.query?.readmore) {
      const contentFromQuery: IContent = JSON.parse(
        router.query?.readmore as string,
      );
      openModalReadMoreDescSet({
        title: contentFromQuery.title,
        description: contentFromQuery.description,
      });
    }
  }, [router.query]);
  return (
    <Modal
      footer={false}
      open={openModalReadMoreDesc ? true : false}
      title={openModalReadMoreDesc?.title}
      onCancel={() => {
        const qq = { ...router.query };
        delete qq?.readmore;
        router.push(
          {
            pathname: router.pathname,
            query: qq,
          },
          undefined,
          { shallow: true },
        );
        openModalReadMoreDescSet(null);
      }}
    >
      <div
        className="mt-4"
        dangerouslySetInnerHTML={{
          __html: openModalReadMoreDesc?.description || "",
        }}
      />
    </Modal>
  );
}

export function ReadMoreSpan({
  title,
  content,
  maxTruncate,
  onClickReadMore,
  classNameReadMore,
  usePathname = false,
}: {
  title?: string;
  content: string;
  maxTruncate: number | { sm: number; lg: number };
  onClickReadMore?: () => void;
  classNameReadMore?: string;
  usePathname?: boolean;
}) {
  const router = useRouter();
  const isMobile = useWindowResize();
  const maxTruncateDynamic =
    typeof maxTruncate === "object"
      ? {
          sm: maxTruncate.sm,
          lg: maxTruncate.lg,
        }
      : {
          sm: maxTruncate,
          lg: maxTruncate,
        };
  return (
    <>
      <span
        dangerouslySetInnerHTML={{
          __html: truncateText(content, maxTruncateDynamic)?.toString() || "",
        }}
      />
      {(typeof maxTruncate === "number"
        ? content?.length >= maxTruncate
        : isMobile
          ? content?.length >= maxTruncate.sm
          : content?.length >= maxTruncate.lg) && (
        <span
          onClick={() => {
            onClickReadMore && onClickReadMore();
            router.push(
              {
                pathname: usePathname
                  ? router.pathname
                  : router.pathname.includes("[id]")
                    ? router.asPath
                    : router.pathname,
                query: {
                  ...router.query,
                  readmore: JSON.stringify({
                    title: title,
                    description: content,
                  }),
                },
              },
              undefined,
              {
                shallow: true,
              },
            );
          }}
          className={`cursor-pointer text-yellow font-bold ${classNameReadMore}`}
        >
          {" "}
          Read More
        </span>
      )}
    </>
  );
}

export function ReadMoreOnly({
  onClickReadMore,
  usePathname = false,
  title,
  content,
  classNameReadMore,
}: {
  onClickReadMore?: () => void;
  usePathname?: boolean;
  title?: string;
  content: string;
  classNameReadMore?: string;
}) {
  const router = useRouter();
  return (
    <span
      onClick={() => {
        onClickReadMore && onClickReadMore();
        router.push(
          {
            pathname: usePathname
              ? router.pathname
              : router.pathname.includes("[id]")
                ? router.asPath
                : router.pathname,
            query: {
              ...router.query,
              readmore: JSON.stringify({
                title: title,
                description: content,
              }),
            },
          },
          undefined,
          {
            shallow: true,
          },
        );
      }}
      className={`cursor-pointer text-yellow font-bold ${classNameReadMore}`}
    >
      Read More
    </span>
  );
}
